import React from 'react';
import Box from '@mui/material/Box';
import useCountdown from 'hooks/useCountdown';
import ShowCounter from './ShowCounter';

const Countdown = ({ progressMessage = null, endMessage = null, isInQuantumWindow }) => {
  const [hours, minutes, seconds] = useCountdown(isInQuantumWindow);

  if (Number(hours) + Number(minutes) + Number(seconds) <= 0) {
    return endMessage;
  }

  return (
    <>
      <Box sx={{ display: 'inline-block', paddingRight: '5px' }}>
        {progressMessage}
      </Box>
      <ShowCounter
        hours={hours}
        minutes={minutes}
        seconds={seconds}
      />
    </>
  );
};

export default Countdown;
